export const getPaymentMethod = (cards, paymentMethodId) =>
  (cards || []).find((c) => c?.id === paymentMethodId) || null;

export const formatPrice = (priceCents) => {
  return (
    "$" +
    (priceCents / 100).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};
